const FileItem = ({ file }) => {
  const fileUrl = file.file;
  const parts = fileUrl.split("/");
  const fileName = parts[parts.length - 1].split("?")[0];

  return (
    <a
      href={fileUrl}
      target="_blank"
      rel="noopener noreferrer"
      title={fileName}
      className="flex items-center min-w-0 hover:underline"
    >
      <span className="text-sm text-primary whitespace-nowrap overflow-hidden text-ellipsis max-w-[60vw] md:max-w-[30vw]">
        📄 {fileName}
      </span>
    </a>
  );
};

export default FileItem;
